$(document).ready(function() {
	$(".js-tab").on("click", function() {
		$(this).parents(".js-tabs-wrap").find(".js-tab").removeClass("active");
		$(this).addClass("active");
		$(this).parents(".js-tabs-wrap").find(".js-tab-content").removeClass("active");
		$(this).parents(".js-tabs-wrap").find(".js-tab-content[data-tab=" + $(this).attr("data-tab") + "]").addClass("active");
		$(window).trigger("resize");
		if ($(".b-masonry").length > 0) {
			setTimeout(function() {
				$('.b-masonry').masonry({
					itemSelector: '.b-masonry__item',
					columnWidth: '.b-masonry__item',
					percentPosition: true
				}).masonry('reload');
			}, 500);
		}
	});
});


// WEBPACK FOOTER //
// ./src/js/general/tabs.js